import { Typography } from 'antd';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

const AuthLayout = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-blue-enterprise-6">
      <div className="min-h-screen grid items-center md:justify-items-center md:px-16 md:py-8 lg:grid-cols-2">
        <div className="hidden pr-32 lg:block">
          <Typography.Title level={1} style={{ color: 'white', fontSize: 48 }}>
            {t('auth.hero')}
          </Typography.Title>
        </div>
        <div className="h-full md:h-auto md:max-w-lg">{children}</div>
      </div>
    </div>
  );
};

export default React.memo(AuthLayout);
